/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷可能フラグ（月曜日）
 * @export
 * @interface EnableShipdayMon1
 */
export interface EnableShipdayMon1 {
}

/**
 * Check if a given object implements the EnableShipdayMon1 interface.
 */
export function instanceOfEnableShipdayMon1(value: object): value is EnableShipdayMon1 {
    return true;
}

export function EnableShipdayMon1FromJSON(json: any): EnableShipdayMon1 {
    return EnableShipdayMon1FromJSONTyped(json, false);
}

export function EnableShipdayMon1FromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableShipdayMon1 {
    return json;
}

export function EnableShipdayMon1ToJSON(json: any): EnableShipdayMon1 {
    return EnableShipdayMon1ToJSONTyped(json, false);
}

export function EnableShipdayMon1ToJSONTyped(value?: EnableShipdayMon1 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

